
import { computed, defineComponent, PropType, reactive } from 'vue'

// UI
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Types
import { TranscriptCalculationT } from '@/core/types/billing.types'

// Composable
import useNotifications from '@/common/composable/useNotifications'

// Realisations
import { printAPI } from '@/core/realisations/print.realisation'

export default defineComponent({
    components: { TheButton },
    props: {
        transcriptId: {
            type: Number,
            required: true
        },
        calculation: {
            type: Object as PropType<TranscriptCalculationT>,
            required: true,
        },
        canPrint: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_pdf_loading: false
        })

        const showFile = (content: File | Blob) => {
            const url = window.URL.createObjectURL(content)
            window.open(url, '_blank')
        }

        const printDocuments = async () => {
            if (state.is_pdf_loading) return

            try {
                state.is_pdf_loading = true

                const response = await printAPI.printTranscriptDocuments(props.transcriptId, props.calculation.invoiceNumber)
                showFile(response)
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При распечатке документов произошла ошибка' })
            } finally {
                state.is_pdf_loading = false
            }
        }

        const isCanRenderPrintButton = computed(() => {
            if (!props.calculation.invoiceNumber) return false
            if (props.calculation.invoiceNumber.includes('FTL')) return false

            return true
        })

        return { state, printDocuments, isCanRenderPrintButton }
    }
})
